const ITI_TRADES = [
  { name: "Drone Technician", durationYears: 0.5, minEdu: 10, isTechnical: true },
  { name: "Welder", durationYears: 1, minEdu: 8, isTechnical: true },
  { name: "Sewing Technology", durationYears: 1, minEdu: 8, isTechnical: false },
  { name: "IOT Technician (Smart City)", durationYears: 1, minEdu: 10, isTechnical: true },
  { name: "Fashion Design & Technology", durationYears: 1, minEdu: 10, isTechnical: false },
  { name: "Computer Operator and Programming Assistant", durationYears: 1, minEdu: 10, isTechnical: false },
  { name: "Fitter", durationYears: 2, minEdu: 10, isTechnical: true },
  { name: "Machinist", durationYears: 2, minEdu: 10, isTechnical: true },
  { name: "Electrician", durationYears: 2, minEdu: 10, isTechnical: true },
  { name: "Electronics Mechanic", durationYears: 2, minEdu: 10, isTechnical: true },
  { name: "Mechanic (Motor Vehicle)", durationYears: 2, minEdu: 10, isTechnical: true },
  { name: "Mechanic (Refrigeration and Air-Conditioning)", durationYears: 2, minEdu: 10, isTechnical: true },
]

const POLY_TRADES = [
  { name: "Civil Engineering (102)", durationYears: 3, minEdu: 10 },
  { name: "Electrical Engineering (105)", durationYears: 3, minEdu: 10 },
  { name: "Mechanical Engineering (131)", durationYears: 3, minEdu: 10 },
  { name: "Computer Science And Engineering (118)", durationYears: 3, minEdu: 10 },
  { name: "Renewable Energy (174)", durationYears: 3, minEdu: 10 },
]

export { ITI_TRADES, POLY_TRADES }
